<template>
  <el-dialog :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh" @close="closeDialog">
    <template #title>
      <span class="el-dialog__title">真留计划服务</span>
    </template>
    <div class="backgroud-white cs-sapService-selector">
      <el-row :gutter="16" type="flex" class="cs-sapService-selector-row">
        <el-col :lg="8" :md="12" :sm="24" v-for="(service, serviceIndex) in sapServiceList" :key="serviceIndex">
          <el-card>
            <template #header>
              <div class="clearfix">
                <span>{{service.Name}}</span>
                <el-checkbox class="float-right" :indeterminate="service._isIndeterminate" v-model="service._isAllSelected"
                  @change="onSelectAllChange(service)" />
              </div>
            </template>
            <div v-for="(serviceItem, serviceItemIndex) in service.ServiceItems" :key="serviceItemIndex">
              <el-checkbox v-model="serviceItem._isSelected" @change="onServiceItemSelectChange(service, serviceItem)">
                {{`${serviceItem.Name} ${getSalePriceText(serviceItem, data.currency)}`}}
              </el-checkbox>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button :disabled="readonly" type="primary" @click="saveChanges">确认添加</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { calculateQuantityTotalBySI } from "@/core/studyAbroadHelper";
import { getStudyAbroadPlanServiceList } from "@/service/studyAbroad.service";

const defaultData = {
  currency: 1,
  isBottomPriceMode: false,
  channelId: 0,
  businessType: 1,
  selectedServices: [],
};

const mixin_generalMethods = {
  methods: {
    calculateTotalPrice(unitPrice, serivceItem) {
      let quantityTotal = calculateQuantityTotalBySI(serivceItem);
      return unitPrice * quantityTotal;
    },
    resetServiceSelectedStatus(service) {
      if (!service || Object.typeOf(service.ServiceItems) !== "array") return;

      let selectedItemCount = service.ServiceItems.count(
        (item) => item._isSelected
      );

      service._isAllSelected =
        selectedItemCount === service.ServiceItems.length;
      service._isIndeterminate =
        selectedItemCount > 0 &&
        selectedItemCount < service.ServiceItems.length;
    },
    resetServiceItemSelectedStatus(service) {
      if (!service || Object.typeOf(service.ServiceItems) !== "array") return;

      service._isIndeterminate = false;
      service.ServiceItems.forEach((serviceItem) => {
        serviceItem._isSelected = service._isAllSelected;
      });
    },
    resetAllServicesSelectedStatus(serviceList) {
      if (Object.typeOf(serviceList) !== "array") return;

      serviceList.forEach((service) => {
        this.resetServiceSelectedStatus(service);
      });
    },
    getSalePriceText(serviceItem, currency) {
      if (!serviceItem) return String.empty;

      let unitPrice = null;
      switch (currency) {
        case this.GLOBAL.currencyType.CNY:
          if (this.data.businessType === this.GLOBAL.enumBusinessType.ToB && this.data.isBottomPriceMode) {
            unitPrice = serviceItem.BottomPriceCNY;
          } else {
            unitPrice = serviceItem.SalePriceCNY;
          }
          break;
        case this.GLOBAL.currencyType.CAD:
          if (this.data.businessType === this.GLOBAL.enumBusinessType.ToB && this.data.isBottomPriceMode) {
            unitPrice = serviceItem.BottomPriceCAD;
          } else {
            unitPrice = serviceItem.SalePriceCAD;
          }
          break;
      }

      if (!unitPrice) return String.empty;

      let totalPrice = this.calculateTotalPrice(unitPrice, serviceItem);

      return this.GLOBAL.currencyType.format(totalPrice, currency);
    },
  },
};

export default {
  name: "serviceSelector",
  mixins: [mixinDevice, mixin_generalMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "65%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      sapServiceList: [],
    };
  },
  created() {
    this.dialogVisible = this.visible;
    this.$nextTick(async () => {
      await this.loadStudyAbroadPlanServiceListFromServer();
      this.reloadSelectStatusFromDataIn();
    });
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
  },
  methods: {
    async loadStudyAbroadPlanServiceListFromServer() {
      let result = await getStudyAbroadPlanServiceList(this.data.channelId);
      let sapServiceList = !!result && result.success ? result.data : [];
      sapServiceList.forEach((service) => {
        service._isIndeterminate = false;
        service._isAllSelected = false;
        service.ServiceItems.forEach((serviceItem) => {
          serviceItem._isSelected = false;
        });
      });

      this.sapServiceList = sapServiceList;
    },
    reloadSelectStatusFromDataIn() {
      if (!this.dialogVisible) return;

      this.sapServiceList.forEach((service) => {
        let selectedService = null;
        if (!!this.data.selectedServices) {
          selectedService = this.data.selectedServices.find(
            (item) => item.id === service.Id
          );
        }
        service.ServiceItems.forEach((serviceItem) => {
          serviceItem._isSelected =
            !!selectedService &&
            selectedService.selectedServiceItems.contains(serviceItem.Id);
        });
      });
      this.resetAllServicesSelectedStatus(this.sapServiceList);
    },
    closeDialog() {
      this.$emit("close");
    },
    onSelectAllChange(service) {
      this.resetServiceItemSelectedStatus(service);
    },
    onServiceItemSelectChange(service, serviceItem) {
      this.resetServiceSelectedStatus(service);
    },
    saveChanges() {
      let dataOut = Object.clone(
        this.sapServiceList.filter(
          (service) => service._isIndeterminate || service._isAllSelected
        )
      );
      dataOut.forEach((service) => {
        service.ServiceItems = Object.clone(
          service.ServiceItems.filter((serviceItem) => serviceItem._isSelected)
        );
      });

      this.$emit("change", dataOut);
    },
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;

      if (this.visible) this.reloadSelectStatusFromDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-sapService-selector {
  padding: 0 40px;
  overflow-y: auto;

  .cs-sapService-selector-row {
    max-height: 600px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    .el-col {
      margin-top: 16px;
    }

    .el-card {
      height: 100%;

      /deep/ .el-card__header {
        font-size: 1.25em;
        font-weight: bold;
      }

      /deep/ .el-card__body {
        .el-checkbox {
          display: inline-flex;

          .el-checkbox__label {
            white-space: normal;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/serviceSelector.vue